import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { checkWidgetAuthorization, checkLocationTokenAndAuthorize } from './utils/check-auth';

export const PublicRoute = ({ component: Component, store, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const tokenAccess = checkLocationTokenAndAuthorize(store, rest);
      if (tokenAccess.access) {
        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
      } else {
        const access = checkWidgetAuthorization(store);
        if (access.access) {
          return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
        } else {
          console.log('Neither in cookies nor in storage and nor in url');
          return <Component {...props} />;
        }
      }
    }}
  />
);
